$(document).ready(function(){
  //$('.sidebar-left-child-linkst.active').parent().addClass("open");
  //$('.sidebar-left-child-linkst.active').parent().prev().addClass("link-color");
  //$('.no-sublink.active').parent().parent().parent().addClass("open");
  //$('.no-sublink.active').parent().parent().parent().prev().addClass("link-color");

  //active link and open menu when menu and submenu have same url
  //$('.sidebar-left-child-linknd .link-color').parent().parent().addClass("open");
  //$('.sidebar-left-child-linknd .link-color').parent().parent().prev().addClass("link-color2");
  //

  //active link and open menu in page product
  $('.pro-act').addClass("link-color");
  $('.pro-act').next().addClass("open");
  //

  // get page title section
  /**var sub_title_1 = $('.sidebar-left-child-linkst.active').parent().prev().text();
  var sub_title_2 = $('.sidebar-left-child-linkst.active .open').prev().text();

  if(sub_title_1 != ''){
    $('.sub_title_1').text(sub_title_1 + '  -  ');
  }

  if(sub_title_2 != ''){
    $('.sub_title_2').text(sub_title_2 + '  -  ');
  }**/
  //

  $('.click-1').click(function(e) {
    $(this).next().toggleClass("open"); 
    $(this).toggleClass("link-color"); 
    e.preventDefault();
  });
  $('.click-2').click(function(e) {
    $(this).next().toggleClass("open"); 
    $(this).toggleClass("link-color2");
    e.preventDefault();
  });

  $(".sidebar-left-child-linknd a").click(function(){  
    $.cookie("title_parent", null, { path: '/' });   
    var title_parent = $(this).parent().parent().parent().parent().prev().text();  
    title_parent = title_parent.toLowerCase();
    title_parent = title_parent.replace(" & ", "-"); 
    title_parent = title_parent.replace(" ", "-");    
    $.cookie("title_parent", title_parent, { path: '/' });
  });

  $(".sidebar-left-child-linkst a").click(function(){  
    $.cookie("title_parent_pr", null, { path: '/' });
    var title_parent_pr = $(this).parent().parent().prev().text();  
    title_parent_pr = title_parent_pr.toLowerCase();
    title_parent_pr = title_parent_pr.replace(" & ", "-");
    title_parent_pr = title_parent_pr.replace(" ", "-");      
    $.cookie("title_parent_pr", title_parent_pr, { path: '/' });
  });

  var cookieValueParent = $.cookie("title_parent_pr");

  $.cookie("title_parent_pr", null, { path: '/' });
  $('.'+cookieValueParent).next().addClass("open");
  $('.'+cookieValueParent).addClass("link-color");

  var cookieValue = $.cookie("title_parent");

  if((cookieValue == null) && (cookieValueParent == null)){
    $.cookie("title_parent", null, { path: '/' });
   // $('.sidebar-left-child-linkst.active').parent().addClass("open");
   // $('.sidebar-left-child-linkst.active').parent().prev().addClass("link-color");
   // $('.sidebar-left-child-linknd .link-color').parent().parent().addClass("open");
    //$('.sidebar-left-child-linknd .link-color').parent().parent().prev().addClass("link-color2");
  }else{
    $.cookie("title_parent", null, { path: '/' });
    $('.'+cookieValue).next().addClass("open");
    $('.'+cookieValue).addClass("link-color");
    $('.sidebar-left-child-linknd .link-color').parent().parent().addClass("open");
    $('.sidebar-left-child-linknd .link-color').parent().parent().prev().addClass("link-color2");
  }

});